module.exports = __webpack_public_path__ + "img/icon-location-closed.fe7a9141.svg";